import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

// นัดหมาย + กำหนดส่งเอกสาร (Dispute Resolution) รายเดือน สำหรับหน้า Calendar
// month: "YYYY-MM", department_id: แผนกของผู้ใช้ → เห็นเฉพาะคดีของแผนกตัวเอง
// all: true (ADMIN) → เห็นทุกแผนก
export const getLitigationCalendar = (month, department_id, all = false) => {
    return httpClient.get(server.LITIGATION_CALENDAR, {
        params: { month, department_id, ...(all ? { all: 1 } : {}) },
    });
};